import React, { useState } from 'react';
import { Box } from '@mui/material';
import { TextField } from '@mui/material';
import InlineEdit from '../common/inline-edit/inline-edit';

const CustomInputFieldWithModal = ({ name, defaultValue, handleConfirmValue }) => {
  return (
    <InlineEdit
      enableApplyTo
      defaultValue={defaultValue}
      label="amount"
      editView={() => (
        <TextField
          name={name}
          fullWidth
          size="small"
          autoFocus
          id="outlined-adornment-weight"
          aria-describedby="outlined-weight-helper-text"
        />
      )}
      readView={() => <Box>{defaultValue || 'Enter amount'}</Box>}
      onConfirm={(form) => handleConfirmValue(form)}
    />
  );
};
export default CustomInputFieldWithModal;
